export abstract class CqrsEvent {}
